import {isBefore, isAfter} from 'date-fns';
import {every, forEach, isEqual, reduce, set} from 'lodash';

export default class MockUtils {
  /**
   * Filtration with sorting
   * First do Sort then filter
   *
   * @param _entities: any[]
   * @param _queryParams: QueryParamsModel
   * @param _filtrationFields: string[]
   */
  baseFilter (key, options) {
    return (_entities, _queryParams, _filtrationFields = []) => {
      // Filtration
      const keys = {
        "pageInfo.sort": "sortOrder",
        "pageInfo.sortNm": "sortField",
        "pageInfo.curPage": "pageNumber",
        "pageInfo.pageSize": "pageSize",
      };

      const _query = reduce(_queryParams, (accu, value, key, obj) => {
        // if (key.startsWith('pageInfo'))
        if (key.startsWith('pageInfo')) {
          set(accu, keys[key], value);
        } else {
          set(accu, ['filter', key], value);
        }
        return accu;
      }, {});

      let entitiesResult = this.searchInArray(
        _entities,
        _query.filter,
        _filtrationFields,
        options,
      );

      // Sorting
      // start
      if (_query.sortField) {
        entitiesResult = this.sortArray(
          entitiesResult,
          _query.sortField,
          _query.sortOrder
        );
      }
      // end

      // Paginator
      // start
      const pageNumber = _query.pageNumber - 1;
      const totalCount = entitiesResult.length;
      const initialPos = pageNumber * _query.pageSize;
      entitiesResult = entitiesResult.slice(
        initialPos,
        initialPos + _query.pageSize
      );
      // end

      const queryResults = {
        [key]: entitiesResult,
        pageInfo: {
          totalCnt: totalCount,
        },
        errorMessage: ""
      };
      return queryResults;
    }
  }

  /**
   * Sort array by field name and order-type
   * @param _incomingArray: any[]
   * @param _sortField: string
   * @param _sortOrder: string
   */
  sortArray(_incomingArray, _sortField = "", _sortOrder = "asc") {
    if (!_sortField) {
      return _incomingArray;
    }

    let result = [];
    result = _incomingArray.sort((a, b) => {
      if (a[_sortField] < b[_sortField]) {
        return _sortOrder === "asc" ? -1 : 1;
      }

      if (a[_sortField] > b[_sortField]) {
        return _sortOrder === "asc" ? 1 : -1;
      }

      return 0;
    });
    return result;
  }

  /**
   * Filter array by some fields
   *
   * @param _incomingArray: any[]
   * @param _queryObj: any
   * @param _filtrationFields: string[]
   */
  searchInArray(
    _incomingArray,
    _queryObj,
    _filtrationFields = [],
    options = {},
  ) {
    const result = [];
    let resultBuffer = [];
    const indexes = [];
    let firstIndexes = [];
    let doSearch = false;

    const getKeyData = (item) => {
      const type = Array.isArray(item) ? 'array' : typeof item;
      let data;
      switch (type) {
        case 'array':
          data = item.map(it => it.key);
          break;
        case 'object':
          data = item.id;
          break;
        default:
          data = item
          break;
      }
      return data;
    };

    _filtrationFields.forEach(item => {
      if (item in _queryObj) {
        _incomingArray.forEach((element, index) => {
          if (element[item] === _queryObj[item]) {
            firstIndexes.push(index);
          }
        });
        firstIndexes.forEach(element => {
          resultBuffer.push(_incomingArray[element]);
        });
        _incomingArray = resultBuffer.slice(0);
        resultBuffer = [].slice(0);
        firstIndexes = [].slice(0);
      }
    });

    const filteredKyes = _queryObj ? Object.keys(_queryObj).filter(key => (
      !(key in _filtrationFields) && Boolean(_queryObj[key]))
    ) : [];

    doSearch = Boolean(filteredKyes.length);

    forEach(_incomingArray,(element, index) => {
      const results = filteredKyes.map(key => {
        const isDateFilter = key === 'fromDate' || key === 'toDate';
        const keyData = getKeyData(element[key]);

        if (key === 'category') {
          const condition = _queryObj[key];
          if (condition[0] && condition[1]) {
            if (isEqual(keyData, condition)) return true;
            return false;
          } else if (condition[0] && !condition[1]) {
            if (keyData[0] === condition[0]) return true;
            return false;
          } else {
            return true;
          }
        } else if (isDateFilter) {
          const condition = _queryObj[key];
          const compareFilter = options.dateCompareField;
          const compareData = element[compareFilter];
          if (!compareFilter || !compareData) return false;
          else if (key === 'fromDate' && isBefore(new Date(condition), compareData)) return true;
          else if (key === 'toDate' && isAfter(new Date(condition), compareData)) return true;
          else return false;
        } else if (keyData || keyData === 0) {
          const searchText = _queryObj[key].toString().trim().toLowerCase();
          const _val = keyData.toString().trim().toLowerCase();
          return _val.indexOf(searchText) > -1 && indexes.indexOf(index) === -1;
        }
        return true;
      });
      every(results) && indexes.push(index);
    });

    if (!doSearch) return _incomingArray;

    indexes.forEach(re => result.push(_incomingArray[re]));

    return result;
  }
}
